import {BubblesField, Panes, TextField} from '@management-ui/core';
import React, {useCallback} from 'react';
import YesNoField from '../../../../components/YesNoField';
import {useMaterialBubbles} from '../../../../hooks';

const Core = ({contact = {}, prefix = ''}) => {
  const materials = useMaterialBubbles();

  const handleReset = useCallback((subject) => {
    if (subject.materials) {
      subject.associated_materials = subject.materials.map(({id}) => id);
    }
    return subject;
  }, []);

  return (
    <Panes
      entity={contact}
      prefix={prefix}
      onReset={handleReset}
      panes={[
        {
          title: 'Contact Details',
          fields: [
            <TextField
              name="name"
              prefix={prefix}
              label="Name"
              rules={{required: 'Please enter a name'}}
            />,
            <TextField
              name="customer_code"
              prefix={prefix}
              label="Customer Code"
            />,
            <TextField
              name="supplier_code"
              prefix={prefix}
              label="Supplier Code"
            />,
            <TextField
              name="eori"
              prefix={prefix}
              label="EORI Number"
            />,
            <TextField
              name="website"
              prefix={prefix}
              label="Website"
            />,
          ]
        },
        {
          title: 'Contact Type',
          fields: [
            <YesNoField
              name="is_customer"
              prefix={prefix}
              label="Is this contact a customer?"
            />,
            <YesNoField
              name="is_supplier"
              prefix={prefix}
              label="Is this contact a supplier?"
            />,
            <YesNoField
              name="is_prospect"
              prefix={prefix}
              label="Is this contact a prospect?"
            />,
            <YesNoField
              name="is_transporter"
              prefix={prefix}
              label="Is this contact a transport company?"
            />
          ]
        },
        {
          title: 'Materials',
          fields: [
            <BubblesField
              name="associated_materials"
              prefix={prefix}
              label="Associated Materials"
              bubbles={materials}
              multiSelect={true}
            />
          ]
        }
      ]}
      title=""/>
  );
};

Core.onSave = (
  {
    name,
    customer_code,
    supplier_code,
    eori,
    website,
    is_customer,
    is_supplier,
    is_prospect,
    is_transporter,
    associated_materials
  }
) => ({
  name,
  customer_code,
  supplier_code,
  eori,
  website,
  is_customer,
  is_supplier,
  is_prospect,
  is_transporter,
  materials: associated_materials
});

export default Core;
